import styles from "../AudioRecorder.module.scss";
import { Button } from "react-bootstrap";
import { ReactComponent as RadioButton } from "assets/svg/radio-btn.svg";
import RecordingTimer from "./RecordingTimer";

const ExternalModeControls = ({
  isRecordingStarted,
  isRecordingFinished,
  isPaused,
  patientAudioSource,
  setPatientAudioSource,
  setShowBrowserErrorBanner,
  initializedStreaming,
  startStreaming,
  recordingTimeString,
  mediaRecorderRef,
  setIsPaused,
}) => {
  const handleStartSession = () => {
    if (
      patientAudioSource === "tab" &&
      !(
        navigator.userAgent.includes("Chrome") ||
        navigator.userAgent.includes("Edge")
      )
    ) {
      setShowBrowserErrorBanner(true);
      return;
    }
    initializedStreaming.current = true;
    startStreaming({
      captureTabAudio: patientAudioSource === "tab",
    });
  };

  const handleToggleRecording = () => {
    if (!mediaRecorderRef.current) return;

    if (isPaused) {
      mediaRecorderRef.current.resume();
      setIsPaused(false);
    } else {
      mediaRecorderRef.current.pause();
      setIsPaused(true);
    }
  };

  return (
    <div className={styles["audio-recorder__center-bottom"]}>
      <RecordingTimer
        recordingTimeString={recordingTimeString}
        isRecordingStarted={isRecordingStarted}
        isPaused={isPaused}
      />
      {!isRecordingStarted && (
        <>
          <div className={styles["device-select"]}>
            <select
              title="patientAudioSource"
              value={patientAudioSource.toString()}
              onChange={(e) =>
                setPatientAudioSource(
                  e.target.value === "microphone" ? "microphone" : "tab",
                )
              }
            >
              <option value="microphone">No headphones</option>
              <option value="tab">Headphones / Shared audio</option>
            </select>
          </div>
          <Button
            variant="outline-primary"
            className={styles["audio-recorder__start-button"]}
            onClick={handleStartSession}
          >
            <RadioButton />
            Start Session
          </Button>
        </>
      )}

      {isRecordingStarted && !isRecordingFinished && (
        <Button onClick={handleToggleRecording}>
          {isPaused ? "Resume" : "Pause"}
        </Button>
      )}
    </div>
  );
};

export default ExternalModeControls;
